import classNames from 'classnames'
import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from '../../Revenue.module.scss'

interface IProps {
  value: string | number
  keyValue: string
  isSubCategory?: boolean
}

export const ShortRevenueName = ({ value, keyValue, isSubCategory }: IProps) => {
  return (
    <div
      className={classNames(styles.textItem, styles.textItem_withMinWidth, styles.alignColumns, {
        [styles.subCategory]: isSubCategory,
      })}
    >
      <Translation text={value as string} />
    </div>
  )
}
